import { Card, CardBody, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Btn, H6 } from '../../../AbstractElements';

import React, { Fragment, useContext, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import TransactionContext from '../../../_helper/Transactions';
const style2 = { width: 60, fontSize: 14, padding: 4 };

const TransactionsTable = (props) => {
  const [dataToShow, setDataToShow] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);

  const { allData, getAllTransactionsData } = useContext(TransactionContext);

  const openModal = (item) => {
    setModal(true);
    setModalItem(item);
  };

  const closeModal = (item) => {
    setModal(false);
    setModalItem(null);
  };

  useEffect(() => {
    getAllTransactionsData();
  }, []);

  const transactionsColumns = [
    {
      name: 'Details',
      selector: (row) => (<div>
        <H6>{row.title}</H6>
        <span>{row.description}</span>
      </div>
      ),
      sortable: false,
      center: false,
      wrap: true,
      minWidth: '400px',
    },
    {
      name: 'Amount',
      selector: (row) => (<>֏{row.amount}</>),
      conditionalCellStyles: [
        {
          when: (row) => 'bank_to_balance' == row.type,
          classNames: ['txt-success']
        },
        {
          when: (row) => 'balance_to_bank' == row.type,
          classNames: ['txt-danger']
        }
      ],
      sortable: true,
      sortFunction: (a, b) => {
        return parseFloat(a.amount) - parseFloat(b.amount)
      },
      center: true,
      minWidth: '100px',
      maxWidth: '150px',
    },
    {
      name: 'Date',
      selector: (row) => row.date,
      sortable: true,
      center: true,
      minWidth: '120px',
      maxWidth: '150px',
    },
    {
      name: 'Status',
      selector: (row) => (<span className='text-capitalize'>{row.status}</span>),
      conditionalCellStyles: [
        {
          when: (row) => 'paid' == row.status,
          classNames: ['txt-success']
        },
        {
          when: (row) => 'failed' == row.status,
          classNames: ['txt-danger']
        },
        {
          when: (row) => 'pending' == row.status,
          classNames: ['txt-info']
        }
      ],
      sortable: false,
      center: true,
      minWidth: '120px',
      maxWidth: '150px',
    },
    {
      name: 'Action',
      selector: (row) => (
        <div>
          <span>
            <Btn attrBtn={{ style: style2, color: 'info', className: 'btn btn-xs', type: 'button', onClick: () => { openModal(row) } }}>View</Btn>
          </span>
        </div>
      ),
      sortable: false,
      center: true,
      minWidth: '160px',
      maxWidth: '160px',
    },
  ]


  return (
    <Fragment>
      <div className='table-responsive product-table'>
        <DataTable noHeader pagination columns={transactionsColumns} data={allData} highlightOnHover={true} striped={true} responsive={true} />
      </div>
      <Modal isOpen={modal} toggle={closeModal} size='xl' centered>
        <ModalHeader toggle={closeModal}>
          {null == modalItem ? 'Transaction' :
            <>
              {modalItem?.title}
              <span className={`${'bank_to_balance' == modalItem.type ? 'txt-success' : 'txt-danger'}`}>{modalItem?.amount}</span>
            </>
          }
        </ModalHeader>
        <ModalBody>
          {null == modalItem ? 'Loading...' :
            <>
              <Card>
                <CardBody>
                  <div>
                    <H6>{modalItem.title}</H6>
                    <span>{modalItem.description}</span>
                  </div>
                </CardBody>
              </Card>
            </>
          }
        </ModalBody>
      </Modal>
    </Fragment>
  );
};
export default TransactionsTable;
